import { Button, type TPlacement, TooltipDesktop } from '@cian/ui-kit';
import { IconFilePdf16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { useDownloadPDF } from '../../../hooks/card/useDownloadPDF';
import { ControlWrapper } from '../components/Controls';

type DownloadPDFContainerProps = {
  tooltipPlacement?: TPlacement;
};

export const DownloadPDFContainer: FC<DownloadPDFContainerProps> = props => {
  const { tooltipPlacement = 'left' } = props;
  const downloadPDF = useDownloadPDF();

  const handleDownloadPDF = useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault();
      downloadPDF();
    },
    [downloadPDF],
  );

  return (
    <ControlWrapper>
      <TooltipDesktop placement={tooltipPlacement} theme="black" title="Скачать PDF">
        <Button
          beforeIcon={<IconFilePdf16 />}
          data-testid="DownloadPDFControl"
          size="XS"
          theme="stroke_secondary"
          onClick={handleDownloadPDF}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
